import { useRef } from "react";

export const useScrollToTop = () => {
  const ref = useRef(null);

  const scrollToTop = () => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return { ref, scrollToTop };
};
